<template>
  <div
    class="list-filter-empty-state text-textLight text-body-2"
    :class="{ 'no-bottom-border': hideBottomBorder }"
  >
    {{ message }}
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: 'No employees match your filters or search. Try adjusting your filters or search term.',
  },
  hideBottomBorder: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="less" scoped>
.list-filter-empty-state {
  padding: 24px 16px;
  text-align: center;
  border-bottom: 1px solid @stroke-default;

  &.no-bottom-border {
    border-bottom: none;
  }
}
</style>
